'use client';

import { useMemo } from 'react';
import { Tabs } from '@/components/Tabs';
import { useGetGameFromRouteParams } from '@/hooks/useGetGameFromParams.hook';

export const PickemsTabs = () => {
  const { game } = useGetGameFromRouteParams();

  const tabs = useMemo(
    () => [
      { label: "Daily Pick 'Ems", path: `/${game}/pickems` },
      { label: 'Rewards', path: `/${game}/pickems/rewards` },
      {
        label: `${game.toUpperCase()} Leaderboard`,
        path: `/${game}/pickems/leaderboard`,
      },
      { label: 'Rules', path: `/${game}/pickems/rules` },
    ],
    [game]
  );

  return <Tabs tabs={tabs} />;
};
